import React from 'react';
import PropTypes from 'prop-types';
import { colors } from "../../../../../styleguide";
import * as CategoriesLabelUI from "./CategoriesLabel.styles";

function CategoriesLabel(_ref) {
  var label = _ref.label,
      labelExtra = _ref.labelExtra,
      external = _ref.external;
  return /*#__PURE__*/React.createElement(React.Fragment, null, label, external && /*#__PURE__*/React.createElement(CategoriesLabelUI.StyledIconExternalFill, {
    color: colors.grey700,
    width: 14,
    height: 14
  }), labelExtra && /*#__PURE__*/React.createElement(CategoriesLabelUI.Parenthesis, null, "(", labelExtra, ")"));
}

CategoriesLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string.isRequired,
  labelExtra: PropTypes.string,
  external: PropTypes.bool.isRequired
} : {};
export default CategoriesLabel;
//# sourceMappingURL=CategoryLabel.js.map